import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

export const useLogout = () => {
  const { logout } = useAuth0();
  const marketingUrl = import.meta.env.VITE_MARKETING_URL || window.location.origin;

  return useCallback(() => {
    // Add query param so marketing site knows to clear its auth cache
    const returnTo = new URL(marketingUrl);
    returnTo.searchParams.set('logged_out', '1');

    logout({
      logoutParams: {
        returnTo: returnTo.toString(),
      },
    });
  }, [logout, marketingUrl]);
};
